import { render } from "./prompt.vue?vue&type=template&id=0d079ec0&ts=true"
import script from "./prompt.vue?vue&type=script&lang=ts"
export * from "./prompt.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__